/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
/* eslint-disable max-classes-per-file */
import React from "react";
import moment from "moment";
import { Grid, TextField } from "@material-ui/core";
import { uniq } from "lodash";
import { CheckboxBasic } from "components/common/form";
import { Column } from "components/common/html";
import { useSidebarFilters } from "../sidebar-filters";
import { FiltersState, sidebarState } from "./state";

const styles = {
  input: {
    padding: "8px 8px 6px",
    fontSize: 14,
    // width: 58,
    fontWeight: 600,
  },
  inputContainer: {
    padding: "0 7px 0",
    maxWidth: 180,
  },
};
type FilterName = keyof FiltersState;

type FilterProps = {
  name: FilterName;
  label: string;
  filters: FilterName[];
  inputStyle?: {
    [className: string]: string;
  }
}

export const FilterEqualityInput: React.FC<FilterProps> = (props) => {
  if (!props.filters.includes(props.name)) return null;
  const { addFilter, removeFilter } = useSidebarFilters();
  return (
    <div style={{ maxWidth: 180 }}>
      <TextField
        variant="outlined"
        style={{ ...styles.input, ...props.inputStyle }}
        value={sidebarState[props.name]}
        onChange={(e) => {
          const val = e.target.value;

          sidebarState.updateKey(props.name, val);

          if (val) {
            addFilter(props.name, val);
          } else {
            removeFilter(props.name);
          }
        }}
        {...props}
      />
    </div>
  );
};


type FilterCheckboxWithInverseType = FilterProps & {
  inverseLabel: string; showForEveryone?: boolean;}
// shows all falsey values ** NOTE ** you must add the inverse input name
// as yourname_inverse into the sidebar state/types
export const FilterCheckboxWithInverse: React.FC<FilterCheckboxWithInverseType> = (props) => {
  if (!props.showForEveryone && !props.filters.includes(props.name)) return null;
  const inverseInputName = `${props.name}_inverse` as FilterName;
  const filterKey = props.name;
  const { addFilter, removeFilter } = useSidebarFilters();
  const checkKey = (inputName: keyof FiltersState, isChecked: boolean) => {
    sidebarState.updateKey(inputName, isChecked);
    if (isChecked) {
      if (inputName === inverseInputName) {
        addFilter(filterKey, true, "inverseBoolean");
        sidebarState.updateKey(props.name, false);
      } else {
        addFilter(filterKey, true);
        sidebarState.updateKey(inverseInputName, false);
      }
    } else {
      removeFilter(filterKey);
    }

  };
  return (
    <div>
      <CheckboxBasic
        name={props.name}
        label={props.label}
        style={{ marginLeft: -16 }}
        labelStyle={{ marginLeft: 0, paddingLeft: 8, width: "initial" }}
        checked={sidebarState[props.name] as boolean}
        onChangeAction={(_el, { target: { checked: isChecked } }) =>
          checkKey(props.name, isChecked)}
      />

      <CheckboxBasic
        name={inverseInputName}
        label={props.inverseLabel}
        style={{ marginLeft: -16 }}
        labelStyle={{ marginLeft: 0, paddingLeft: 8, width: "initial" }}
        checked={sidebarState[inverseInputName] as boolean}
        onChangeAction={(_evt: any, { target: { checked: isChecked } }) =>
          checkKey(inverseInputName, isChecked)}
      />
    </div>
  );
};


export const FilterCheckbox: React.FC<Omit<FilterProps, "name"> & {showForEveryone?: boolean; name: string}> = (props) => {
  const { addFilter, removeFilter } = useSidebarFilters();
  const name = props.name.replace("filter_", "") as FilterName;
  if (!props.showForEveryone && !props.filters.includes(name)) return null;
  return (
    <CheckboxBasic
      name={props.name}
      label={props.label}
      style={{ marginLeft: -16 }}
      labelStyle={{ marginLeft: 0, paddingLeft: 8, width: "initial" }}
      checked={sidebarState[name] as boolean}
      onChangeAction={(_el, { target: { checked: isChecked } }) => {
        sidebarState.updateKey(name, isChecked);
        if (isChecked) {
          addFilter(name, true);
        } else {
          removeFilter(name);
        }
      }}
    />
  );
};

// Checkbox that uses a string facet value instead of a boolean
// eg. if checked and facetValue is "rent" it will return
// results that have a value of "rent"

export const FilterFacetCheckbox: React.FC<FilterProps & {
  showForEveryone?: boolean;
  facetValue: string;
}> = (props) => {
  if (!props.showForEveryone && !props.filters.includes(props.name)) return null;
  const nameWithFacet = `${props.name}:${props.facetValue}`;
  const { addFilter, removeFilter } = useSidebarFilters();
  const currentValue = sidebarState[props.name] as string[];

  return (
    <CheckboxBasic
      name={nameWithFacet}
      label={props.label}
      style={{ marginLeft: -16 }}
      labelStyle={{ marginLeft: 0, paddingLeft: 8, width: "initial" }}
      checked={currentValue.includes(props.facetValue)}
      onChangeAction={(_el, { target: { checked: isChecked } }) => {
        if (isChecked) {
          const updatedValue = [...currentValue, props.facetValue];
          sidebarState.updateKey(props.name, uniq(updatedValue));
          addFilter(props.name, props.facetValue);
        } else {
          sidebarState.updateKey(props.name, currentValue
            .filter((val) => val !== props.facetValue));
          removeFilter(props.name);
        }
      }}
    />
  );
};

// eslint-disable-next-line max-lines-per-function
type FilterRangeProps = Omit<FilterProps, "name"> & {
  year?: boolean;
  containerStyle?: React.CSSProperties;
  name: string;
}
const FilterRangeContainer: React.FC<FilterRangeProps> = (props) => {
  const { name, year } = props;
  const minName = `${name}_min` as FilterName;
  const maxName = `${name}_max` as FilterName;
  const [minVal, setMinVal] = React.useState(sidebarState[minName] as string);
  const [maxVal, setMaxVal] = React.useState(sidebarState[maxName] as string);
  const { addFilter, removeFilter } = useSidebarFilters();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, type: "min" | "max") => {
    const newValue = event.target.value;
    const currentMin = type === "min" ? newValue : minVal;
    const currentMax = type === "max" ? newValue : maxVal;
    if (type === "min") {
      setMinVal(newValue);
      sidebarState.updateKey(minName, newValue);
    }
    if (type === "max") {
      setMaxVal(newValue);
      sidebarState.updateKey(maxName, newValue);
    }

    removeFilter(name);
    const applyFilterAndRefinement = (filterName: string, value: string, isMin: boolean) => {
      let minMax = isMin;
      let actualValue = parseInt(value, 10);
      if (year) {
        actualValue = moment().subtract(value, "years").unix();
        minMax = !minMax;
      }
      const suffix = minMax ? "Min" : "Max";

      if (Number.isNaN(actualValue)) {
        removeFilter(filterName, `range${suffix}`);
      } else {
        addFilter(filterName, `${actualValue}`, `range${suffix}`);
      }
    };

    if (currentMin) applyFilterAndRefinement(name, currentMin, true);
    if (currentMax) applyFilterAndRefinement(name, currentMax, false);
  };

  if (!props.filters.includes(props.name as FilterName)) return null;
  return (
    <Grid item container spacing={2}
      style={{ ...styles.inputContainer, ...props.containerStyle }}>
      <Column width={6}>
        <TextField
          variant="outlined"
          inputProps={{
            min: 0,
          }}
          name={minName}
          type="number"
          label="Min"
          value={sidebarState[minName]}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, "min")}
        />
      </Column>
      <Column width={6}>
        <TextField
          variant="outlined"
          inputProps={{
            min: 0,
          }}
          name={maxName}
          type="number"
          label="Max"
          value={sidebarState[maxName]}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, "max")}
        />
      </Column>
    </Grid>
  );
};

export const FilterRange = FilterRangeContainer;

export const FilterOver55: React.FC<FilterProps & {showForEveryone?: boolean}> = (props) => {
  if (!props.showForEveryone && !props.filters.includes(props.name)) return null;
  const name = "applicant_dob_over_55";
  const { addFilter, removeFilter } = useSidebarFilters();

  return (
    <CheckboxBasic
      name="applicant_dob_over_55"
      label="Applicant is 55 or older"
      style={{ marginLeft: -16 }}
      labelStyle={{ marginLeft: 0, paddingLeft: 8, width: "initial" }}
      checked={sidebarState[name]}
      onChangeAction={(_el, { target: { checked: isChecked } }) => {
        sidebarState[name] = isChecked;
        if (isChecked) {
          const minYear = moment().subtract(55, "years").unix();
          addFilter("applicant_dob", `${minYear}`, "rangeMax");
        } else {
          removeFilter("applicant_dob");
        }
      }}
    />
  );
};

export const AmiRadioInput: React.FC<FilterProps & {
  value: string;
  amiRange: {
    value: string;
    min: string;
    max: string;
  }
}> = (props) => {
  const { addFilter } = useSidebarFilters();
  return (
    <input
      type="radio"
      name={props.name}
      style={{ marginRight: 4 }}
      value={props.value}
      checked={props.value === sidebarState[props.name]}
      onChange={(e) => {
        const { amiRange, name: inputName } = props;
        sidebarState.updateKey(inputName, e.target.value);
        addFilter("household_income", { min: amiRange.min, max: amiRange.max }, "range");
      }}
    />
  );
};

const IncomeFilterContainer: React.FC<Omit<FilterRangeProps, "name"> & {name: string}> = (props) => {
  const { name } = props;
  const minName = `${name}_min` as FilterName;
  const maxName = `${name}_max` as FilterName;
  const { addFilter } = useSidebarFilters();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, type: "min" | "max") => {
    const newValue = event.target.value;
    if (type === "min") {
      sidebarState.updateKey(minName, newValue);
      addFilter(name, newValue, "rangeMin");
    }
    if (type === "max") {
      sidebarState.updateKey(maxName, newValue);
      addFilter(name, newValue, "rangeMax");
    }
  };

  if (!props.filters.includes(props.name as FilterName)) return null;
  return (
    <Grid item container spacing={2}
      style={{ ...styles.inputContainer, ...props.containerStyle }}>
      <Column width={6}>
        <TextField
          variant="outlined"
          inputProps={{
            min: 0,
          }}
          name={minName}
          type="number"
          label="Min"
          value={sidebarState[minName]}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, "min")}
        />
      </Column>
      <Column width={6}>
        <TextField
          variant="outlined"
          inputProps={{
            min: 0,
          }}
          name={maxName}
          type="number"
          label="Max"
          value={sidebarState[maxName]}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event, "max")}
        />
      </Column>
    </Grid>
  );
};

export const IncomeFilter = IncomeFilterContainer;
